// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shopList[data-v-08837983] {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  flex: 1;\n  overflow: hidden;\n}\n.shopList__left[data-v-08837983] {\n  width: 15%;\n  background-color: white;\n  margin: 3px;\n  margin-right: 15px;\n}\n.shopList__right[data-v-08837983] {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 3px;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
